import type { CSSProperties, ReactNode } from "react";

import "./Card.css";

export function Card({
  className = "",
  style,
  children,
}: {
  className?: string;
  style?: CSSProperties;
  children: ReactNode;
}) {
  return (
    <div className={`card ${className}`.trim()} style={style}>
      {children}
    </div>
  );
}

export function CardHead({
  title,
  subtitle,
  actions,
  children,
}: {
  title?: ReactNode;
  subtitle?: ReactNode;
  actions?: ReactNode;
  children?: ReactNode;
}) {
  if (children) return <div className="card-head">{children}</div>;
  return (
    <div className="card-head">
      <div>
        {title && <h3 className="card-title">{title}</h3>}
        {subtitle && <p className="card-sub">{subtitle}</p>}
      </div>
      {actions && <div className="card-head-actions">{actions}</div>}
    </div>
  );
}

export function CardBody({ children, className = "" }: { children: ReactNode; className?: string }) {
  return <div className={`card-body ${className}`.trim()}>{children}</div>;
}

export function CardFoot({ children }: { children: ReactNode }) {
  return <div className="card-foot">{children}</div>;
}
